import {useEffect, useRef, useState} from 'react';
import {WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Checkbox, Form, message} from 'antd';
import {ResponseStatus} from '@/utils/request';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Product, ProductUom} from '@/services/mdm/product';
import {ProFormInstance} from '@ant-design/pro-form';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {FormSa} from '@/services/sales/sa';
import {FieldProps, wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {buildFormItem, getPdDetailPrevField} from "@/pages/sales/sa/PriceDiscountApply/components/DetailBase";
import {ProductPrice} from "@/services/mdm/productprice";
import {responseIsOk} from "@/utils/response";
import moment from "moment/moment";
import {
  PRODUCT_BY_QTY_LEVELS,
  PRODUCT_BY_QTY_DISABLED_LEVELS
} from "@/pages/sales/sa/GeneralActivityApply/components/DetailBase";

const PdDiscountGtDetailApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const {formSaDetail, formSa, rowIndex, rows} = props.data;
  const [expandKeysProduct, setExpandKeysProduct] = useState<string[]>();

  useEffect(() => {
    if (formSaDetail) {
      formRef.current?.setFieldsValue({
        ecName: formSaDetail.ecName,
        revenueTypeName: formSaDetail.revenueTypeName,
        priceSellinBefore: formSaDetail.priceSellinBefore,
        priceSellinBeforeMin: formSaDetail.priceSellinBeforeMin,
        priceLimit: formSaDetail.priceLimit,
        priceLimitMin: formSaDetail.priceLimitMin,
        priceSellinAfter: formSaDetail.priceSellinAfter,
        priceSellinAfterMin: formSaDetail.priceSellinAfterMin,
        quantitySellinForecast: formSaDetail.quantitySellinForecast,
        revenueSellinForecast: formSaDetail.revenueSellinForecast,
        quantityMin: formSaDetail.quantityMin,
        isLimited: formSaDetail.isLimited,
        amount: formSaDetail.amount,
        remark: formSaDetail.remark,
        roiForecast: formSaDetail.roiForecast,
        discountAmountSellin: formSaDetail.discountAmountSellin,
        priceLimitBelowRate: formSaDetail.priceLimitBelowRate,
      });
      if (formSaDetail.activityStartDate) {
        formRef.current?.setFieldsValue({
          activityDate: [
            moment(formSaDetail.activityStartDate),
            moment(formSaDetail.activityEndDate),
          ]
        });
      }

      if (formSaDetail.supplyStartDate) {
        formRef.current?.setFieldsValue({
          supplyDate: [
            moment(formSaDetail.supplyStartDate),
            moment(formSaDetail.supplyEndDate),
          ]
        });
      }
      if (formSaDetail.productBuyIds) {
        Product.searchAll({
          productIds: formSaDetail.productBuyIds,
          isActive: true
        }).then(response => {
          if (response && response.data) {
            setExpandKeysProduct(response.data.map(item => `${item.productId}`));
            formRef.current?.setFieldsValue({
              productBuyIds: response.data.map(item => ({
                value: item.productId,
                label: item.codeOrName
              }))
            });
          }
        });
        handleProductBuyChange(formSaDetail.productBuyIds).then();
      }
    }
  }, [formSaDetail]);

  const handleProductBuyChange = async (productBuyIds: any) => {
    const productBuyId = WdiSelectFormat.getvalue(productBuyIds);
    const fieldsValues: any = {
      priceSellinBefore: null,
      priceLimit: null,
      priceSellinBeforeMin: null,
      priceLimitMin: null,
      quantityConvert: null,
    };
    if (!wdiCore.Object.IsNullOrUndefined(productBuyId)) {
      fieldsValues.quantityConvert = await getProductUom(productBuyId);
      fieldsValues.priceSellinBefore = await getPriceSellinBefore(productBuyId);
      if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.priceSellinBefore)) {
        fieldsValues.priceSellinBeforeMin = wdiCore.Number.ToNumber(fieldsValues.priceSellinBefore / fieldsValues.quantityConvert, 4);
      }
      fieldsValues.priceLimit = await getPriceLimit(productBuyId);
      if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.priceLimit)) {
        fieldsValues.priceLimitMin = wdiCore.Number.ToNumber(fieldsValues.priceLimit / fieldsValues.quantityConvert, 4);
      }
    }
    formRef.current?.setFieldsValue(fieldsValues);
    handlePriceSellinAfterChange();
    calculateAmount();
  }


  // 自动获取=产品别改变后获取供货价/转换数量
  // （如单位为0则=1，否则=所选产品别+所选单位在product_uom取min转换数量(为0或取不到则报错"产品别【**】+单位【**】取不到单位转换数量")）
  const getPriceSellinBefore = async (productBuyId: any) => {
    const priceResp = await ProductPrice.getRegionPriceSellin1({
      productIds: productBuyId,
      custSysCode: formSa.custSysCode,
      custTypeId: formSa.custTypeId,
      boIds: formSa.boIds,
    });
    if (!responseIsOk(priceResp)) {
      message.error(priceResp.message);
      return undefined;
    }
    return priceResp.data.priceInVat;
  }

  const getPriceLimit = async (productBuyId: any) => {
    const priceLimitResp = await ProductPrice.getRegionPriceLimit({
      productIds: productBuyId,
      custSysCode: formSa.custSysCode,
      custTypeId: formSa.custTypeId,
      boIds: formSa.boIds,
    });
    if (!responseIsOk(priceLimitResp)) {
      message.error(priceLimitResp.message);
      return undefined;
    }
    return priceLimitResp.data.priceInVat;
  }

  const getProductUom = async (productBuyId: any) => {
    const response = await ProductUom.getProductUomMin(productBuyId);
    if (response.data && response.data.quantityConvert && response.data.quantityConvert > 1) {
      return response.data.quantityConvert;
    } else {
      return 1;
    }
  }

  const handlePriceSellinAfterChange = () => {
    const fieldsValues: any = {priceSellinAfterMin: null,};
    const {priceSellinAfter, quantityConvert} = formRef.current?.getFieldsValue();
    if (priceSellinAfter && quantityConvert) {
      fieldsValues.priceSellinAfterMin = wdiCore.Number.ToNumber(priceSellinAfter / quantityConvert, 4);
    }
    formRef.current?.setFieldsValue(fieldsValues);
  }

  // 前台毛利率 计算列：百分比，不可修改，=(促销零售价-促销供货价) /促销零售价
  // 价差 计算列：限价-促销供货价
  // 预计出货销售额 计算列：= 预计销量 * 原供货价;
  // 申请金额 计算列：价差*预估销量
  // 预计费比 计算列：申请金额/预计出货销售额
  const calculateAmount = () => {
    const fieldsValues = {
      discountAmountSellin: null,
      revenueSellinForecast: null,
      amount: null,
      roiForecast: null,
      priceLimitBelowRate: null
    };
    const {
      priceLimit, priceSellinBefore, priceSellinAfter, quantitySellinForecast
    } = formRef.current?.getFieldsValue();

    if (!wdiCore.Object.IsNullOrUndefined(priceSellinBefore) && !wdiCore.Object.IsNullOrUndefined(priceSellinAfter)) {
      let discountAmountSellin = wdiCore.Number.ToNumber(priceLimit - priceSellinAfter, 4);
      if (discountAmountSellin < 0) {
        discountAmountSellin = 0;
      }
      fieldsValues.discountAmountSellin = discountAmountSellin;
    }
    if (!wdiCore.Object.IsNullOrUndefined(quantitySellinForecast) && !wdiCore.Object.IsNullOrUndefined(priceSellinAfter)) {
      fieldsValues.revenueSellinForecast = wdiCore.Number.ToNumber(priceSellinAfter * quantitySellinForecast, 2);
    }
    if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.discountAmountSellin) && !wdiCore.Object.IsNullOrUndefined(quantitySellinForecast)) {
      fieldsValues.amount = wdiCore.Number.ToNumber(Number(fieldsValues.discountAmountSellin) * quantitySellinForecast, 2);
    }
    if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.amount) && fieldsValues.revenueSellinForecast) {
      fieldsValues.roiForecast = wdiCore.Number.ToNumber(Number(fieldsValues.amount) / fieldsValues.revenueSellinForecast, 4);
    }
    if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.discountAmountSellin) && !wdiCore.Object.IsNullOrUndefined(priceLimit)) {
      fieldsValues.priceLimitBelowRate = wdiCore.Number.ToNumber(Number(fieldsValues.discountAmountSellin) / Number(priceLimit), 4);
    }

    formRef.current?.setFieldsValue(fieldsValues);
  }

  return (
    <WdiModalForm
      {...HorzLayoutOpts}
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      onFinish={async (values) => {
        const {productBuyIds, activityDate, supplyDate, ...entity} = values;
        entity.productBuyIds = WdiSelectFormat.getvalue(productBuyIds);

        if (activityDate && activityDate.length == 2) {
          entity.activityStartDate = moment(activityDate[0]).format('YYYY-MM-DD');
          entity.activityEndDate = moment(activityDate[1]).format('YYYY-MM-DD');
        }
        if (supplyDate && supplyDate.length == 2) {
          entity.supplyStartDate = moment(supplyDate[0]).format('YYYY-MM-DD');
          entity.supplyEndDate = moment(supplyDate[1]).format('YYYY-MM-DD');
        }

        const response = await FormSa.Buttons.validateDetail({
          rowIndex: rowIndex,
          formSa: {...formSa},
          formSaDetail: Object.assign({}, getPdDetailPrevField(formSaDetail), entity),
          formSaDetails: rows
        });
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (props.onSave) {
          response.data = Object.assign({}, {rowIndex: rowIndex}, response.data);
          props.onSave(response);
        }
        return;
      }}
    >
      {buildFormItem("activityDate")}
      {buildFormItem("supplyDate")}


      <Form.Item name="productBuyIds" label="购买产品" rules={[{required: true, message: '购买产品不能为空!'}]}>
        <WdiTreeSelect {...{
          multiple: false,
          placeholder: "请选择购买产品",
          defaultExpandKeys: expandKeysProduct,
          dataLoading: async (params) => {
            const response = await Product.searchAll(
              Object.assign({
                productLevels: PRODUCT_BY_QTY_LEVELS.join(),
                isActive: true,
              }, params)
            );
            const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
              textField: "codeOrName",
              valueField: "productId",
              id: "productId",
              pId: "parentId",
              level: "productLevel",
              disabledLevel: PRODUCT_BY_QTY_DISABLED_LEVELS,
            }, response.data);
            return {treeData, dict};
          },
          onChange: (value) => {
            handleProductBuyChange(value).then();
          },
        }} />
      </Form.Item>
      <Form.Item name="quantityConvert" hidden={true}>
        <WdiInputNumber readOnly/>
      </Form.Item>
      <Form.Item name="priceSellinBefore" label="原供货价(箱/大袋)"
                 rules={[{required: true, message: '原供货价(箱/大袋)不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item name="priceLimit" label="限价(箱/大袋)" rules={[{required: true, message: '限价(箱/大袋)不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item name="priceSellinAfter" label="促销供货价(箱/大袋)"
                 rules={[{required: true, message: '促销供货价(箱/大袋)不能为空!'}]}>
        <WdiInputNumber min={0} digits={4} onChange={() => {
          handlePriceSellinAfterChange();
          calculateAmount();
        }}/>
      </Form.Item>
      <Form.Item name="priceSellinBeforeMin" label="原供货价(中包)"
                 rules={[{required: true, message: '原供货价(中包)不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item name="priceLimitMin" label="限价(中包)"
                 rules={[{required: true, message: '限价(中包)不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item name="priceSellinAfterMin" label="促销供货价(中包)"
                 rules={[{required: true, message: '促销供货价(中包)不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item
        name="quantitySellinForecast" label="预计出货销量(箱/大袋)"
        rules={[{required: true, message: '预计出货销量不能为空!'}]}>
        <WdiInputNumber min={0} onChange={() => {
          calculateAmount();
        }}/>
      </Form.Item>
      <Form.Item
        name="revenueSellinForecast" label="预计出货销售额"
        rules={[{required: true, message: '预计出货销售额不能为空!'}]}>
        <WdiInputNumber readOnly/>
      </Form.Item>
      <Form.Item name="quantityMin" label="起订量(箱/大袋)">
        <WdiInputNumber min={0}/>
      </Form.Item>
      <Form.Item name="isLimited" label="是否限量" valuePropName="checked">
        <Checkbox/>
      </Form.Item>
      <Form.Item name="amount" label="申请金额" rules={[{required: true, message: '申请金额不能为空!'}]}>
        <WdiInputNumber readOnly/>
      </Form.Item>

      {buildFormItem("remark")}
      {buildFormItem("roiForecast")}

      <Form.Item name="discountAmountSellin" label="价差(箱/大袋)" rules={[{required: true, message: '价差不能为空!'}]}>
        <WdiInputNumber readOnly digits={4}/>
      </Form.Item>
      <Form.Item name="priceLimitBelowRate" label="低于限价比例">
        <WdiInputNumber readOnly format={"p"}/>
      </Form.Item>

      {buildFormItem("ecName")}
      {buildFormItem("revenueTypeName")}
    </WdiModalForm>
  );
};

export default PdDiscountGtDetailApp;
